import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=8e44dd9e&scoped=true&"
import script from "./NewMessage.vue?vue&type=script&lang=js&"
export * from "./NewMessage.vue?vue&type=script&lang=js&"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=8e44dd9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e44dd9e",
  null
  
)

export default component.exports